module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.company) ? _c('div', {
    staticClass: "CompanyInfo"
  }, [_c('div', {
    staticClass: "Col"
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.company.Name) + " " + _vm._s(_vm.company.Type) + "\n\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Sitz der Gesellschaft:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Address && _vm.company.Address.Street) + " " + _vm._s(_vm.company.Address && _vm.company.Address.House))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Address && _vm.company.Address.PLZ) + " " + _vm._s(_vm.company.Address && _vm.company.Address.City))])])]), _vm._v(" "), _c('div', {
    staticClass: "Col"
  }, [_c('p', [_c('span', [_c('span', [_vm._v("Tel. ")]), _c('span'), _vm._v(_vm._s(_vm.company.Phone))]), _vm._v(" "), (_vm.company.Fax) ? _c('span', [_c('span', [_vm._v("Fax ")]), _c('span'), _vm._v(_vm._s(_vm.company.Fax))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.company.Email
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.company.Email))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.company.Site
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.company.Site))])])])]), _vm._v(" "), _c('div', {
    staticClass: "Col"
  }, [_c('p', [_c('span', [_vm._v("Geschäftsführer:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Owners))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Registration))])])]), _vm._v(" "), _c('div', {
    staticClass: "Col"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.company.BankDetails && _vm.company.BankDetails.BankName))]), _vm._v(" "), _c('span', {
    staticClass: "CompanyInfo-Iban"
  }, [_c('span', [_vm._v("IBAN: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.BankDetails && _vm.company.BankDetails.IBAN))])]), _vm._v(" "), _c('span', [_vm._v("BIC: " + _vm._s(_vm.company.BankDetails && _vm.company.BankDetails.BIC))]), _vm._v(" "), _c('span', [_vm._v("USt-IdNr.: " + _vm._s(_vm.company.TaxNumber))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1638431a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/CompanyAddress.vue
// module id = 158
// module chunks = 4